import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../tooltip-info/tooltip-info.component';
import { NgClass } from '@angular/common';
import { TooltipInReportComponent } from "../tooltip-in-report/tooltip-in-report.component";
import { FieldSequentialHeaderComponent } from "../field-sequential-header/field-sequential-header.component";

@Component({
    selector: 'field-type-number',
    templateUrl: './field-type-number.component.html',
    standalone: true,
    imports: [NgClass, TooltipInfoComponent, TooltipLawComponent, TooltipModule, AfTranslateDirective, InputNumberModule, FormsModule, AfTranslatePipe, TooltipInReportComponent, FieldSequentialHeaderComponent]
})
export class FieldTypeNumberComponent implements OnChanges {
  fieldTypeNumber:any = {
    titleField: '',
    separator: true,
    decimals: 6,
    inputNumber: '',
    minValue: 0,
    placeholder: ''
  };
  isLanding: Boolean = this.customLanding.isLanding();
  custom: any = this.customLanding.getCustom();

  constructor(private commonUtilsService:CommonUtilsService,
    private customLanding: CustomLandingFactory) { }

  @Input() field:any;
  @Input() preSelectItem:any;
  @Input() concept:any;
  @Input() decimals:any;
  @Output() itemSelected = new EventEmitter;
  @Output() openRelatedInfo = new EventEmitter;

  ngOnChanges(): void {
    let field: any = this.field;
    if(field){
      this.fieldTypeNumber.decimals = this.decimals || this.decimals===0?this.decimals:6;
      this.fieldTypeNumber.titleField = field.extendedLabel && field.extendedLabel !== ''? field.extendedLabel : field.label;
      this.fieldTypeNumber.minValue = field.positive?0:-99999999999999999999.99;
      this.fieldTypeNumber.placeholder = field.placeholder?field.placeholder:'';
      // field.minValue = field.minValue || field.minValue === 0? field.minValue : -99999999999999999999.99;
      if(!field.references){
        field.references = [];
      }
      field.id = field.generateId || !field.fieldId?this.commonUtilsService.createId() : field.fieldId;
      if(field.decimals){
        this.fieldTypeNumber.decimals = field.decimals ;
      }else if(field.fieldTypeId === 'percent'){
        this.fieldTypeNumber.decimals = 2 ;
      }else if(field.fieldTypeId === 'money'){
        this.fieldTypeNumber.decimals = 2 ;
        this.fieldTypeNumber.titleField += ' ('+ field.currencySymbol +')'
      }
      if(this.preSelectItem === ''){
        delete this.preSelectItem;
      }
      this.fieldTypeNumber.inputNumber = this.preSelectItem;
      if(field.inReport !== null && field.inReport !== undefined){
        this.fieldTypeNumber.inReport = field.inReport.indexOf('|') === -1? [field.inReport] : field.inReport.split('|')
      }
    }
  }

  openModalRelatedInfo(fieldRelatedInfo:any, e:any){
    e.stopPropagation();
    e.preventDefault();
    this.openRelatedInfo.emit({relatedInfo: fieldRelatedInfo});
  }

  resetNumber(){
    this.fieldTypeNumber.inputNumber = null;
    this.field.errorInForm = false;
    this.field.error = false;
    this.itemSelected.emit({newValue: null});
    if(this.concept){
      this.commonUtilsService.configureConceptErrorForm(this.field, this.concept);
    }
  }

  changeInField(){
    if(this.fieldTypeNumber.inputNumber != null && this.fieldTypeNumber.inputNumber != ''){
      this.checkMinAndMaxValues();
    }
    this.itemSelected.emit({newValue: this.fieldTypeNumber.inputNumber});
  }

  checkMinAndMaxValues(){
    this.field.errorInForm = false;
    this.field.error = false;
    if(((this.field.minValue || this.field.minValue === 0) && this.fieldTypeNumber.inputNumber < this.field.minValue) || ((this.field.maxValue || this.field.maxValue === 0) && this.fieldTypeNumber.inputNumber > this.field.maxValue)){
      this.field.errorInForm = true;
    }
    if(this.concept){
      this.commonUtilsService.configureConceptErrorForm(this.field, this.concept);
    }
  }
}
